import { getBrandProfileId } from 'utils/organization';

import { Organization } from 'types';

type RequiredOrganisationFields =
  & Pick<Organization, 'ccmStatus'>
  & Parameters<typeof getBrandProfileId>[0]

export const isOrgNewCcmBrand = (
  organization: null | RequiredOrganisationFields,
  predicate: () => boolean
) => {
  const brandProfileId = getBrandProfileId(organization);
  const ccmStatus = organization?.ccmStatus ?? '';

  return brandProfileId === null && ['only', 'enabled'].includes(ccmStatus) && !predicate();
};
